import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter.boolean('active', 'Active'),
  ], [])
}

const TYPE_OPTIONS = [
  { label: "HTML", value: "html" },
  { label: "HTTP Get", value: "http_get" },
  { label: "HTTP Post", value: "http_post" },
  { label: 'Twyne Offer', value: 'twyne_offer' },
]
